// extracted by mini-css-extract-plugin
module.exports = {"container":"partials-credits-container","icon":"partials-credits-icon","label":"partials-credits-label"};